import React, { lazy, Suspense, useContext } from "react";
import { FormNavigationContext } from "../../FormNavigation/FormNavigationProvider";

const Chat = lazy(() => import("../../../containers/WebChat/Chat"));

export const Navigation = () => {
  const navContext = useContext(FormNavigationContext);

  // Add safe destructuring with fallback to handle undefined context
  const isChatVisible = Array.isArray(navContext) ? navContext[1] : false;

  if (!isChatVisible) return null;

  return (
    <div
      className={"chatButton"}
      data-testid="chat-button"
      style={{
        position: "fixed",
        left: "20px",
        bottom: "150px",
        zIndex: 1000
      }}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Chat />
      </Suspense>
    </div>
  );
};
